import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { setYearList,setMonthList,setDateRange,dynamicUrl,formatDate,DownloadFile } from './Function';
import { useDynamicLink } from './DynamicUse';
import { Row,Col,Card,Form,InputGroup,Table,Placeholder,Button,Spinner } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
const Internship = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const dynamicLinkData = useDynamicLink(231);
    const[Internships,setInternships]=useState([]);
    const[isLoading, setLoading] = useState(true);
    const[isLoadMore, setLoadMore] = useState(true);
    const[Rows, setRows] = useState(0);
    const[keyword, setKeyword] = useState('');
    const[year, setYear] = useState(0);
    const[month, setMonth] = useState(0);
    const KeywordChange = (e) => setKeyword(e.target.value.trim() || '');
    const YearChange = (e) => setYear(Number(e.target.value) || 0);
    const MonthChange = (e) => setMonth(Number(e.target.value) || 0);
    //const currentYear = new Date().getFullYear();
    useEffect(()=>
    {
        fetchInternship(true);
        // eslint-disable-next-line
    },[])
    const fetchInternship = async (isReset) => 
    {
        if (isReset === true) 
        {
            setRows(0);
            setInternships([]);
        }
        try 
        {
            setLoading(true);
            var keywordText = keyword || 'none';
            const currentRows = isReset ? 0 : Rows;       
            const { startDate, endDate } = setDateRange(year, month, 0, 0, 1);
            const callApi = global.config.API_URL + `internship/list/${keywordText}/${startDate}/${endDate}/${currentRows}`;
            if(global.config.IsPrint) console.info('fetchInternship : API', callApi);
            const response = await fetch(callApi);
            const result = await response.json();
            if(result.length > 0 )
            {
                Promise.all(
                    result.map(e => {
                        const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.sip_id + "/sipPoster")
                                .then(upp => upp.json());
                        const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.sip_id + "/sipPosterHi")
                            .then(upph => upph.json());
                        const fetch3 = fetch(global.config.API_URL + "upload/details/0/" + e.sip_id + "/sipBrochure")
                            .then(upb => upb.json());
                        const fetch4 = fetch(global.config.API_URL + "upload/details/0/" + e.sip_id + "/sipBrochureHi")
                            .then(upbh => upbh.json());
                        return Promise.all([fetch1, fetch2, fetch3, fetch4])
                            .then(([upp,upph,upb,upbh]) => {
                                return {
                                    ...e,
                                    upp,
                                    upph,
                                    upb,
                                    upbh
                                };
                            });
                    })
                ).then(allResponse => {   
                    allResponse.forEach((el, i) => {
                        result[i].ePoster = el.upp;
                        result[i].ePosterHi = el.upph;
                        result[i].Brochure = el.upb;
                        result[i].BrochureHi = el.upbh;
                    });
                    setInternships(prevResults => Rows === 0 ? result : [...prevResults, ...result]);
                    setRows(currentRows + 30);             
                    setLoadMore(true);
                }).catch(error => {
                    console.error('fetchInternship File :', error);
                });
            }
            else
            {
                setLoadMore(false);
            }
            if( global.config.IsPrint === true ) { console.info('fetchInternship : Result',result); }
        }
        catch (error) { console.error('fetchInternship : Error', error.message); }
        finally{ setLoading(false); }
    };
    const handleSubmit = (e) => 
    {
        if (e)
        {
            e.preventDefault();
            if (!keyword && year === 0 && month === 0) 
            {
                alert(t('FilterAlert'));
                return;
            }
        }
        fetchInternship(true);
    }
    return (
        <Card className='bg-secondary-subtle mb-4'>
            <Card.Header className='text-center fs-3' data-aos="flip-up" data-aos-duration="1500">
                {appLanguage === 'hi' ? 'ग्रीष्मकालीन इंटर्नशिप कार्यक्रम' : 'Summer Internships Programme'}
            </Card.Header>
            <Card.Body className='text-start'>
                <Card className='mb-3'>
                    <Card.Body>
                        <Form onSubmit={handleSubmit}>
                            <div className='mb-2 fw-bold'>{t('FilterSearch')}</div>
                            <Row className='g-2'>
                                <Col md={6} data-aos="fade-right" data-aos-duration="1000">
                                    <Form.Control type="text" placeholder={t('FilterPlaceholder')} onChange={KeywordChange} value={keyword} />
                                </Col>
                                <Col md={6} data-aos="fade-right" data-aos-duration="1000">
                                    <InputGroup>
                                        <Form.Select onChange={YearChange} value={year}>
                                            <option value={0}>{t('FilterYear')}</option>
                                            {setYearList(0, 0).map((year) => (
                                                <option key={year} value={year}>
                                                    {year}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        <Form.Select onChange={MonthChange} value={month}>
                                            <option value={0}>{t('FilterMonth')}</option>
                                            {setMonthList().map(({ value, label }) => (
                                                <option key={value} value={value}>
                                                    {label}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        <Button type="submit" className='btn btn-info'><i className="bi bi-search"></i> {t('FilterSearch')}</Button>
                                    </InputGroup>                                    
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>               
                <Table responsive bordered className='rounded-top text-center overflow-hidden mb-0'>
                <thead>
                    <tr>
                        <th>{t('ProgrammeName')}</th>
                        <th>{t('UploadDate')}</th>
                        <th>{t('Duration')}</th>
                        <th>{t('LastDateApply')}</th>
                        <th>{t('Details')}</th>
                    </tr>
                </thead>
                {isLoading ? (
                <tbody>
                {[...Array(10)].map((_,index) => (
                    <tr key={index}> 
                        <th className="table-success"><Placeholder xs={10} bg="success" /></th>
                        <td><Placeholder xs={10} bg="dark" /></td>
                        <td><Placeholder xs={10} bg="dark" /></td>
                        <td><Placeholder xs={10} bg="dark" /></td>
                        <td className="text-center">
                            <Button className="btn btn-light w-25"><Placeholder xs={10} bg="dark" /></Button>
                            <Button className="btn btn-light w-25"><Placeholder xs={10} bg="dark" /></Button>
                            <Button className="btn btn-light w-100"><Placeholder xs={10} bg="dark" /></Button>
                            <Button className="btn btn-light w-100"><Placeholder xs={10} bg="dark" /></Button>
                        </td>
                    </tr>
                ))}
                </tbody>
                ) : (
                <React.Fragment>
                {Internships && Internships.length > 0 ? (                
                <tbody>
                {Internships.map((sip,index)=>(
                    <tr key={index}>
                        <th className="table-success">{appLanguage === 'hi' ? (sip.sip_display_en === "1" ? sip.sip_name_hi || '' : sip.sip_name_hi || sip.sip_name) : sip.sip_name}</th>
                        <td width={120}>{formatDate(sip.sip_date)}</td>
                        <td width={120}>
                            {formatDate(sip.sip_start_date)}
                            <div>TO</div>
                            {formatDate(sip.sip_end_date)}
                        </td>
                        <td width={120}>{formatDate(sip.sip_last_date)}</td>                                
                        <td width={350} className="text-center">
                            {sip.ePoster.length > 0 && <div className='d-flex align-items-center justify-content-between mb-2'>
                                {appLanguage === 'hi' ? 'ई-पोस्टर' : 'e-Poster'}
                                <span dangerouslySetInnerHTML={{ __html: DownloadFile(appLanguage,sip.ePoster,sip.ePosterHi)}} />
                            </div>}
                            {sip.Brochure.length > 0 && <div className='d-flex align-items-center justify-content-between mb-2'>
                                {appLanguage === 'hi' ? 'विवरणिका' : 'Brochure'}
                                <span dangerouslySetInnerHTML={{ __html: DownloadFile(appLanguage,sip.Brochure,sip.BrochureHi)}} />
                            </div>}
                            {sip.sip_apply_link && <div className='d-flex align-items-center justify-content-between mb-2'>
                                {appLanguage === 'hi' ? 'अभी आवेदन करें' : 'Apply Now'}
                                <a href={sip.sip_apply_link} className="btn btn-info" target="_blank" rel="noopener noreferrer">
                                    {appLanguage === 'hi' ? 'यहाँ क्लिक करें' : 'Click Here'}
                                </a>
                            </div>}
                            {sip.sip_details_link && <div className='d-flex align-items-center justify-content-between mb-2'>
                                {appLanguage === 'hi' ? 'अधिक जानकारी के लिए' : 'For more details'}
                                <a href={sip.sip_details_link} className="btn btn-info" target="_blank" rel="noopener noreferrer">
                                    {appLanguage === 'hi' ? 'यहाँ क्लिक करें' : 'Click Here'}
                                </a>
                            </div>}
                        </td>
                    </tr>
                ))}
                </tbody>
                ) : (
                <tbody>
                    <tr>
                        <td colSpan={5} className='text-center'>{t('NoResult')}</td>
                    </tr>
                </tbody>
                )}                
                </React.Fragment>
                )}
                </Table>
            </Card.Body>
            <Card.Footer className='d-flex justify-content-between bg-white'>
                {dynamicLinkData && dynamicLinkData.map((sp,index)=>(
                    <NavLink key={index} to={dynamicUrl(sp)} className='btn btn-info'>
                        {t('Archives')}
                    </NavLink>
                ))} 
                {isLoadMore &&
                <Button variant='info' onClick={() => fetchInternship(false)} disabled={isLoading}>
                    {isLoading ? (
                    <React.Fragment>
                        <Spinner animation="grow" variant="light" size="sm" />
                        <Spinner animation="grow" variant="danger" size="sm" />
                        <span className='ms-2'>{t('PleaseWait')}</span>
                    </React.Fragment>
                    ) : t('LoadMore')}
                </Button>}                
            </Card.Footer>
        </Card>
    );    
}
export default Internship;